<script>
export default {
  name: 'rejected-orders',
  data () {
    return {
      rejectedCount: 10
    }
  },
  methods: {
    async getRejectedCount () {
      /*this.rejectedCount = await this.$HASURA.webForms.countWhere({
        draft: { _eq: false },
        status: { _eq: 'rejected' }
      })*/
    }
  },
  async mounted () {
    //this.getRejectedCount()
  }
}
</script>
<template>
  <b-card no-body bg-variant="soft-danger" class="mini-stats-wid">
    <b-card-body>
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex justify-content-between">
          <b-avatar variant="danger" size="lg" class="mini-stat-icon mr-3 my-0"
            ><i :class="`bx bx-error-alt font-size-24`"></i
          ></b-avatar>
          <div class="media-body">
            <h5 class="text-muted font-weight-medium">Rejected Orders</h5>
            <p class="card-title-desc mb-0">
              You have
              <strong>{{ rejectedCount | thousands(1) }}</strong> rejected
              orders!
            </p>
          </div>
        </div>
        <div class="d-flex justify-content-start">
          <b-btn
            variant="link"
            class="alert-link px-0 pb-0 mr-4 text-danger"
            :to="{ name: 'my-orders', query: { status: 'rejected' } }"
            ><i class="bx bx-form mr-2"></i>View Orders</b-btn
          >
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>
